var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col" }, [
      _c(
        "div",
        { staticClass: "card" },
        [
          _c(
            "card-header",
            { attrs: { title: _vm.$router.currentRoute.meta.title } },
            [
              !_vm.serverError && _vm.iban_id
                ? _c(
                    "router-link",
                    {
                      directives: [
                        {
                          name: "can",
                          rawName: "v-can:edit",
                          value: _vm.permissionPrefix + "_bank",
                          expression: "`${permissionPrefix}_bank`",
                          arg: "edit"
                        }
                      ],
                      staticClass: "btn btn-primary btn-sm",
                      attrs: {
                        to: {
                          name: _vm.ibansRoutePrefix + ".edit",
                          params: { iban_id: _vm.iban_id }
                        }
                      }
                    },
                    [_c("i", { staticClass: "fa fa-edit" })]
                  )
                : _vm._e()
            ],
            1
          ),
          _c("div", { staticClass: "card-body" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-6" }, [
                _vm.serverError
                  ? _c("div", { staticClass: "alert alert-danger" }, [
                      _c("strong", [
                        _vm._v(_vm._s(_vm.$t("labels.error")) + " : ")
                      ]),
                      _vm._v(" " + _vm._s(_vm.serverError) + " ")
                    ])
                  : _vm._e()
              ])
            ]),
            !_vm.serverError
              ? _c(
                  "div",
                  { staticClass: "row" },
                  [
                    _c("input-text", {
                      attrs: {
                        options: {
                          id: "iban_name",
                          transPrefix: _vm.transPrefix + ".fields",
                          label: "iban_name",
                          disabled: true
                        }
                      },
                      model: {
                        value: _vm.iban_name,
                        callback: function($$v) {
                          _vm.iban_name = $$v
                        },
                        expression: "iban_name"
                      }
                    }),
                    _c("input-text", {
                      attrs: {
                        options: {
                          id: "iban_number",
                          transPrefix: _vm.transPrefix + ".fields",
                          label: "iban_number",
                          disabled: true
                        }
                      },
                      model: {
                        value: _vm.iban_number,
                        callback: function($$v) {
                          _vm.iban_number = $$v
                        },
                        expression: "iban_number"
                      }
                    }),
                    _c("select-banks", {
                      attrs: {
                        options: {
                          id: "iban_bank_id",
                          transPrefix: _vm.transPrefix + ".fields",
                          label: "iban_bank",
                          disabled: true
                        }
                      },
                      model: {
                        value: _vm.iban_bank_id,
                        callback: function($$v) {
                          _vm.iban_bank_id = $$v
                        },
                        expression: "iban_bank_id"
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ]),
          _c("div", { staticClass: "card-footer" }, [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col text-right" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "btn btn-neutral btn-sm",
                      attrs: { to: { name: _vm.routePrefix + ".index" } }
                    },
                    [_c("i", { staticClass: "fa fa-arrow-left" })]
                  )
                ],
                1
              )
            ])
          ])
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }